import React, { useContext } from 'react';
import TextInput from '../UI/TextInput';
import EmailInput from '../UI/EmailInput';
import MultiSelect from '../UI/MultiSelect';
import DateRange from '../UI/DateRange';
import PasswordInput from '../UI/PasswordInput';
import TextArea from '../UI/TextArea';
import { TabContext } from '../../context/TabContext';
import Radio from '../UI/Radio';
import Select from '../UI/Select';
import { CITY_INSTALLATION_LIST } from '../../constans';

const EditProfileTabOption = props => {
  const { 
    register, 
    onChangeHandler, 
    handleMultiChange, 
    inputValue, 
    list, 
    selectValue, 
    handleTimeCallback, 
    setInputValue, 
    onChangeSingleValue
  } = useContext(TabContext);

  return (
    <div className="advanced-option">
      <h6>
        {props.label}
      </h6>
      {props.type === "text" && (
        <TextInput 
          name={props.name} 
          type={props.type} 
          register={register()}
          value={inputValue[props.info_type][props.name] || ""}
          onChange={onChangeSingleValue}
          placeholder="Type something..."
          setInputValue={setInputValue}
          inputValue={inputValue}
          info_type={props.info_type}
        />
      )}
      {props.type === "textarea" && (
        <TextArea 
          name={props.name} 
          register={register()}
          value={inputValue[props.info_type][props.name]}
          onChange={onChangeSingleValue}
          placeholder="Up To 600 characters"
          info_type={props.info_type}
        />
      )}
      {props.type === "email" && (
        <EmailInput 
          name={props.name} 
          type={props.type} 
          register={register()}
          value={inputValue[props.info_type][props.name]}
          onChange={onChangeSingleValue}
          placeholder="Type something..."
          info_type={props.info_type}
        />
      )}
      {props.type === "password" && (
        <PasswordInput 
          name={props.name} 
          tabs={true}
          type={props.type} 
          register={register()}
          value={inputValue[props.info_type]}
          onChange={onChangeSingleValue}
          placeholder="Type something..."
          info_type={props.info_type}
        />
      )}
       {props.type === "tel" && (
        <input 
          name={props.name}
          id={props.name}
          ref={register()}
          placeholder="Type something..."
          onChange={onChangeSingleValue && ((event) => onChangeSingleValue(event, props.name, props.info_type))}
          value={(inputValue && inputValue[props.info_type][props.name]) || ''}
          type={props.type}
        />
      )}
      {props.type === "date" && (
        <DateRange
          handleTimeCallback={handleTimeCallback}
          name={props.name}
          id={props.name}
          wrapStyle="advanced-picker-wrap"
          cancelCallback = {() => {setInputValue({
            ...inputValue,
            [props.name]: {}
          })}}
          isPicked = {()=>Object.keys(inputValue[props.info_type][props.name]).length === 0}
        />
      )}
      {props.type === "select" && (
        <MultiSelect 
          onChangeHandler={onChangeHandler}
          handleMultiChange={handleMultiChange}
          name={props.name}
          list={list}
          selectValue={selectValue.filter(item => item.type === props.name)}
          styles="react-select-container advanced"
          prefixStyles="react-select"
          indicator={false}
          info_type={props.info_type}
        />
      )}
      {props.type === "single_select" && props.name === "installation" && (
        <Select 
          handleMultiChange={onChangeHandler}
          name={props.name}
          inputValue={inputValue.officer.name}
          list={CITY_INSTALLATION_LIST}
          styles="react-select-input-container advanced"
          prefixStyles="react-select-input"
          indicator={false}
          info_type={props.info_type}
          isClear={false}
          defaultValue={{value: "Fort Bragg", label: "Fort Bragg", type: "installation"}}
        />
      )}
      {props.type === "radio" && (
        <Radio 
          register={register()}
          props={props}
          onChangeSingleValue={onChangeSingleValue}
          value={inputValue[props.info_type][props.name]}
          info_type={props.info_type}
        />
      )}
    </div>
  )
}

export default EditProfileTabOption;